import { Text, View } from 'react-native'
import { useTranslation } from 'react-i18next'
import { FONTS, RADIUS, SPACING } from '@/lib/brand'
import { GlassSurface } from '@/components/ui/GlassSurface'
import type { TourDrivingRouteStatus } from './use-tour-driving-route'

export function TourRouteMapChrome({
  routeStatus,
  colors,
}: {
  routeStatus: TourDrivingRouteStatus
  colors: { surface: string; border: string; textPrimary: string; textSecondary: string }
}) {
  const { t } = useTranslation()

  return (
    <View
      pointerEvents="none"
      style={{
        position: 'absolute',
        top: SPACING.sm,
        left: SPACING.sm,
        right: SPACING.sm,
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: SPACING.xs,
        zIndex: 2,
      }}
    >
      {routeStatus === 'road' ? (
        <GlassSurface
          tone="regular"
          visualRole="chrome"
          radius={RADIUS.full}
          style={{
            height: 28,
          }}
          contentStyle={{
            paddingHorizontal: SPACING.sm + 2,
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Text style={{ fontFamily: FONTS.body, fontSize: 12, color: colors.textPrimary }}>
            {t('tours.map.driving_route')}
          </Text>
        </GlassSurface>
      ) : null}
      {routeStatus === 'loading' ? (
        <GlassSurface
          tone="quiet"
          visualRole="chrome"
          radius={RADIUS.full}
          style={{
            height: 28,
          }}
          contentStyle={{
            paddingHorizontal: SPACING.sm + 2,
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Text style={{ fontFamily: FONTS.body, fontSize: 12, color: colors.textSecondary }}>
            {t('tours.map.loading_route')}
          </Text>
        </GlassSurface>
      ) : null}
      {routeStatus === 'unavailable' ? (
        <GlassSurface
          tone="quiet"
          visualRole="chrome"
          radius={RADIUS.full}
          style={{
            minHeight: 28,
          }}
          contentStyle={{
            paddingHorizontal: SPACING.sm + 2,
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Text style={{ fontFamily: FONTS.body, fontSize: 12, color: colors.textSecondary }}>
            {t('tours.map.route_unavailable')}
          </Text>
        </GlassSurface>
      ) : null}
    </View>
  )
}
